import { User } from '../user/user.model';

export class LeadPotentialSeller {
    potentialSellers: User[];

    constructor(potentialSellers?: User[]) {
        this.potentialSellers = potentialSellers;
    }
}
